import { render } from "./RoleDetails.vue?vue&type=template&id=569d156c&scoped=true"
import script from "./RoleDetails.vue?vue&type=script&lang=js"
export * from "./RoleDetails.vue?vue&type=script&lang=js"

import "./RoleDetails.vue?vue&type=style&index=0&id=569d156c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569d156c"]])

export default __exports__